var exports = {
  "kL": "MobileBottomNav.module__container___b1hzZ2",
  "oi": "MobileBottomNav.module__navButton___b1hzZ2",
  "Mv": "MobileBottomNav.module__navButtonActive___b1hzZ2",
  "XA": "MobileBottomNav.module__navButtonInactive___b1hzZ2",
  "VK": "MobileBottomNav.module__voiceButton___b1hzZ2",
  "Kk": "MobileBottomNav.module__icon___b1hzZ2",
  "Pf": "MobileBottomNav.module__label___b1hzZ2",
};

module.exports = exports;
